<con-app
  [appName]="appName"
  [sideNavCollection]="links"
  [logoImage]="'../../assets/imgs/ConnectLogo_Black.svg'"
  [companyName]="' '"
  [hideTM]="true"
  [helpButtonLink]="helpLink"
  [homeLink]="homeLink"
  [accountLabel]="account?.name"
  [accountIcon]="account?.icon">
</con-app>